"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _filteritem = _interopRequireDefault(require("./filteritem/filteritem"));

var _index = require("../../../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _filtersholder_styles = _interopRequireDefault(require("./filtersholder_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles

/* ========== ~~~~~~~~~~ EXPORT :  MENU : FILTER : HOLDER ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_filtersholder_styles.default)(function (props) {
  return _react.default.createElement("div", {
    className: "filterholder ".concat(props.classes.filterholder, " menuitems")
  }, _react.default.createElement("div", {
    className: 'carrot'
  }), _react.default.createElement("div", {
    className: 'inner'
  }, _react.default.createElement(_index.Grid, {
    name: 'filters',
    direction: "horizontal"
  }, Object.keys(props.filters).map(function (filterName) {
    return _react.default.createElement(_filteritem.default, {
      key: "filteritem-".concat(filterName),
      name: filterName,
      filter: props.filters[filterName],
      state: props.filterState[filterName],
      onSelect: props.onSelect
    });
  })), _react.default.createElement("div", {
    className: "buttons"
  }, _react.default.createElement(_index.Button, {
    type: 'action',
    action: props.onClear,
    variant: "secondary",
    name: "clearFilter",
    text: "Clear Filter"
  }), _react.default.createElement(_index.Button, {
    type: 'action',
    handleClick: props.onApply,
    variant: "secondary",
    name: "applyFilter",
    text: "Apply Filter"
  }))));
});

exports.default = _default;